import React from 'react';
import Loader from 'src/components/Loader';
import SchedulingOverlayHeader from '../components/SchedulingOverlayHeader/SchedulingOverlayHeader';
import ServiceRequestSummaryTable from '../components/ServiceRequestSummaryTable/ServiceRequestSummaryTable';
import CalendlySchedulingPanel from '../components/CalendlySchedulingPanel/CalendlySchedulingPanel';
import ManualSchedulingPanel from '../components/ManualSchedulingPanel/ManualSchedulingPanel';
import {
  useServiceRequestSchedulingOrchestrator,
  UseServiceRequestSchedulingOrchestratorReturn,
} from '../CustomHooks/useServiceRequestSchedulingOrchestrator';
import { IServiceRequestDetail } from 'src/services/api/ServiceRequest/apiContracts';
import './service-request-scheduling.scss';

interface ServiceRequestSchedulingProps {
  serviceRequest: IServiceRequestDetail;
  onClose: () => void;
  onEventScheduled: (data: any) => void;
}

const ServiceRequestScheduling = ({
  serviceRequest,
  onClose,
  onEventScheduled,
}: ServiceRequestSchedulingProps) => {
  const {
    isLoading,
    schedulingUrl,
    calendlyEmbedUrl,
    slotSelected,
    scheduledAt,
    availableServiceTimes,
    propertyName,
    propertyAddress,
    suiteNumber,
    homeownerName,
    homeownerProfileImage,
    onTimeSlotSelection,
    onScheduledAtChange,
    onCalendlyEventScheduled,
    onScheduleClick,
  }: UseServiceRequestSchedulingOrchestratorReturn =
    useServiceRequestSchedulingOrchestrator({
      serviceRequest,
      onClose,
      onEventScheduled,
    });

  return (
    <>
      <SchedulingOverlayHeader onClose={onClose} />
      <div className="service-request-scheduling">
        <div className="scheduling-wrapper">
          <h2 className="scheduling-title">Schedule Service Request</h2>
          <ServiceRequestSummaryTable
            propertyName={propertyName}
            propertyAddress={propertyAddress}
            suiteNumber={suiteNumber}
            homeownerName={homeownerName}
            homeownerProfileImage={homeownerProfileImage}
          />
          {isLoading ? (
            <Loader center={true} />
          ) : (
            <div className="preferred-appointment-times">
              <h3>Preferred appointment times</h3>
              <div className="scheduling-calendar-box">
                {schedulingUrl ? (
                  <CalendlySchedulingPanel
                    preferredServiceTimes={serviceRequest.preferredServiceTimes}
                    calendlyEmbedUrl={calendlyEmbedUrl}
                    onTimeSlotSelection={onTimeSlotSelection}
                    onCalendlyEventScheduled={onCalendlyEventScheduled}
                  />
                ) : (
                  <ManualSchedulingPanel
                    preferredServiceTimes={serviceRequest.preferredServiceTimes}
                    slotSelected={slotSelected}
                    availableServiceTimes={availableServiceTimes}
                    scheduledAt={scheduledAt}
                    onTimeSlotSelection={onTimeSlotSelection}
                    onScheduledAtChange={onScheduledAtChange}
                    onScheduleClick={onScheduleClick}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ServiceRequestScheduling;